__webpack_require__.p = "https://ru-cdn.chesshotel.com/_next/";